<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row>
      <v-spacer />
      <v-col cols="12" sm="11">
        <v-card class="mx-auto" id="palmSiteHeaderToolbar">
          <v-toolbar color="teal" dark class="overflow-fix">
            <v-toolbar-title style="color: white; font-size: 1rem">
              <router-link to="/forum/1" v-slot="{ href }" custom>
                <a @click="navigateBackToTopicList(href)" style="color: white"
                  >Plant Forum</a
                >
              </router-link>
              |
              <router-link to="/forum/2" v-slot="{ href }" custom>
                <a @click="navigateBackToTopicList(href)" style="color: white"
                  >Swaps &amp; Sales</a
                >
              </router-link>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn
              v-if="userIsModerator() && this.apiData && this.apiData.length > 0"
              class="ma-2 red"
              outlined
              @click="showMoveTopicDialog()"
            >
              <i
                aria-hidden="true"
                class="v-icon notranslate mdi mdi-folder-move theme--light"
                style="font-size: 16px"
              ></i>
            </v-btn>
            <v-btn
              v-if="userIsModerator() && this.apiData && this.apiData.length > 0"
              class="ma-2 red"
              outlined
              @click="confirmDeleteCurrentTopic()"
            >
              <i
                aria-hidden="true"
                class="v-icon notranslate mdi mdi-delete theme--light"
                style="font-size: 16px"
              ></i>
            </v-btn>
            <v-btn
              v-if="userIsModerator() && this.apiData && this.apiData.length > 0"
              class="ma-2"
              :color="getTopicClosedColour(this.apiData[0])"
              @click="toggleClosed(apiData[0])"
            >
              <i
                aria-hidden="true"
                class="v-icon notranslate mdi mdi-key theme--light"
                style="font-size: 16px"
              ></i>
            </v-btn>

            <v-btn
              v-if="userIsModerator() && this.apiData && this.apiData.length > 0"
              class="ma-2"
              :color="getTopicStickyColour(this.apiData[0])"
              outlined
              @click="toggleSticky(apiData[0])"
            >
              <i
                aria-hidden="true"
                class="v-icon notranslate mdi mdi-star theme--light"
                style="font-size: 16px"
              ></i>
            </v-btn>

            <v-btn
              v-if="userIsModerator() && this.apiData && this.apiData.length > 0"
              class="ma-2"
              :color="getTopicAnnouncementColour(this.apiData[0])"
              outlined
              @click="toggleAnnouncement(apiData[0])"
            >
              <i
                aria-hidden="true"
                class="v-icon notranslate mdi mdi-trumpet theme--light"
                style="font-size: 16px"
              ></i>
            </v-btn>
          </v-toolbar>

          <v-card class="ma-0 pa-0" v-if="apiData && apiData.length > 0">
            <v-card-title>
              {{ apiData[0].subject }}
              <v-spacer />
            </v-card-title>
            <v-card-text class="darkgrey-text"
              >First Posted On
              {{
                formatDateTime(apiData[0].messageDateSerial, apiData[0].messageTimeSerial)
              }}
            </v-card-text>
          </v-card>
          <v-card
            class="ma-0 pa-0"
            v-if="apiData && apiData.length > 0 && apiData[0].topicClosed"
          >
            <v-card-title class="ma-0 pa-0">
              <v-alert type="warning" width="100%"
                >This topic is closed for editing</v-alert
              >
            </v-card-title>
          </v-card>
          <v-card class="ma-0 pa-0" v-if="!userIsLoggedIn">
            <v-card-title class="ma-0 pa-0">
              <v-alert type="warning" width="100%"
                >Please
                <router-link class="eps_white" to="/register">register</router-link> or
                <router-link class="eps_white" to="/login">login</router-link> to reply to
                this post</v-alert
              >
            </v-card-title>
          </v-card>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row class="ma-0 pa-0">
      <v-spacer />
      <v-col cols="12" sm="11" class="ma-0 pa-0">
        <v-pagination
          v-if="apiData"
          v-model="page"
          :length="getPagesAvailable"
          total-visible="15"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          circle
          @input="paginationChanged()"
        ></v-pagination>

        <v-skeleton-loader
          class="mx-auto mb-6"
          type="article@2"
          v-if="!apiData"
        ></v-skeleton-loader>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row no-gutters>
      <v-spacer />
      <v-col cols="12" sm="11" no-gutters>
        <v-row
          v-for="post in pageData"
          :key="post.id"
          :id="'post' + post.id"
          :ref="'post' + post.id"
        >
          <v-col cols="2" v-if="!smallScreenAndDown">
            <v-card class="d-none d-sm-flex" elevation="16">
              <v-card-text class="ma-0 pa-2">
                <v-list-item-avatar outline rounded size="80" v-if="post.avatar">
                  <v-img :src="getFullAvatarUrl(post.avatar)"></v-img>
                </v-list-item-avatar>
                <v-card-text class="name ma-0 pa-0 black-text"
                  ><b>
                    {{ post.forename + " " + post.surname }}
                  </b></v-card-text
                >
                <div class="county black-text">
                  {{ post.county }}
                </div>
                <div class="country black-text">
                  {{ post.country }}
                </div>
                <div class="posts black-text">Posts: {{ post.totalPosts }}</div>
                <div class="joined black-text">
                  Joined: {{ formatDate(post.dateJoined.slice(0, 8)) }}
                </div>
              </v-card-text>
            </v-card>
            <v-spacer />
          </v-col>

          <v-col cols="12" md="10">
            <v-spacer />
            <v-card
              class="mt-0 mb-0 ml-1 mr-1 pa-0"
              :elevation="cardElevation(post)"
              :style="getPostBackgroundColour(post)"
            >
              <v-row>
                <v-col v-if="smallScreen" class="pl-2 pr-2 ml-2 mr-2" cols="1">
                  <v-list-item-avatar
                    class="text-center"
                    rounded
                    size="60"
                    v-if="post.avatar"
                  >
                    <v-img :src="getFullAvatarUrl(post.avatar)"></v-img>
                  </v-list-item-avatar>
                </v-col>
                <v-col class="text-left">
                  <v-card-subtitle
                    class="text-left text-top ml-2 pl-2 mr-0 pr-0 mb-0 pb-0 black-text"
                  >
                    <v-icon v-if="!post.messageRead" large color="red">
                      mdi-new-box
                    </v-icon>
                    <b
                      >Posted On:
                      {{ formatDateTime(post.messageDateSerial, post.messageTimeSerial) }}
                    </b>
                    <span v-if="userIsModerator()" class="ml-1 pl-1 black-text"
                      ><small>[{{ post.id }}]</small></span
                    >
                    <v-card-text
                      class="ma-0 pa-0 d-flex black-text"
                      v-if="smallScreenAndDown"
                      ><b>
                        By: {{ post.forename + " " + post.surname }}
                        {{ getLocationText(post) }}</b
                      >
                    </v-card-text>
                  </v-card-subtitle>
                </v-col>
              </v-row>

              <v-card
                elevation="3"
                outline
                class="ma-2 pa-2"
                v-if="
                  formatPostMessage(post) && formatPostMessage(post).trim().length > 5
                "
              >
                <v-card-text
                  class="pa-2 ma-2 black-text"
                  v-html="formatPostMessage(post)"
                >
                </v-card-text>
              </v-card>

              <v-row class="mt-0 pt-0 mb-0 pb-0 ml-2" v-if="post.image1 || post.image2">
                <v-col class="mt-0 pt-0 mb-0 pb-0" cols="12">
                  <h5><em>Images below imported from prior EPS website</em></h5>
                </v-col>
              </v-row>
              <v-row v-if="post.image1 || post.image2">
                <v-col cols="6" class="mt-0 pt-0 mb-0 pb-0">
                  <v-card-text v-if="post.image1">
                    <v-card-title v-if="post.image1Title" style="word-break: break-word">
                      {{ post.image1Title }}</v-card-title
                    >
                    <v-img
                      outlined
                      eager
                      :src="getOldImageUrl(post.userId, post.image1)"
                    />
                  </v-card-text>
                </v-col>
                <v-col cols="6" class="mt-0 pt-0 mb-0 pb-0">
                  <v-card-text v-if="post.image2">
                    <v-card-title v-if="post.image2Title" style="word-break: break-word">
                      {{ post.image2Title }}</v-card-title
                    >
                    <v-img
                      outlined
                      eager
                      :src="getOldImageUrl(post.userId, post.image2)"
                    />
                  </v-card-text>
                </v-col>
              </v-row>

              <v-row v-if="post.postImages" class="ma-0 pa-0">
                <v-spacer />
                <v-col
                  v-for="image in post.postImages"
                  :key="image.imageUrl"
                  class="ma-0 pa-2"
                  :xxsm="getSmSizeForImage(image, post.postImages)"
                  cols="12"
                  sm="6"
                >
                  <v-card
                    width="100%"
                    class="mx-auto"
                    elevation="16"
                    :loading="image.loading"
                  >
                    <v-card-text>
                      <v-card-title class="darkgrey-text" style="word-break: break-word">
                        {{ image.imageCaption }}</v-card-title
                      >
                      <v-card-actions
                        class="pa-0 ma-0"
                        v-if="userIsModerator() || post.owner"
                      >
                        <v-btn
                          :loading="image.loadingLeft"
                          class="ma-2 info eps_white"
                          outlined
                          @click="rotatePostImage(post, image, -90)"
                          alt="Rotate Left"
                          ><i
                            aria-hidden="true"
                            class="v-icon notranslate v-icon--center mdi mdi-rotate-left theme--light"
                            style="font-size: 16px"
                          ></i>
                        </v-btn>
                        <v-btn
                          :loading="image.loadingRight"
                          class="ma-2 info eps_white"
                          outlined
                          @click="rotatePostImage(post, image, 90)"
                          alt="Rotate Right"
                          ><i
                            aria-hidden="true"
                            class="v-icon notranslate v-icon--center mdi mdi-rotate-right theme--light"
                            style="font-size: 16px"
                          ></i>
                        </v-btn>
                      </v-card-actions>
                      <div class="d-flex flex-row">
                        <v-spacer />
                        <img
                          class="ml-auto"
                          outlined
                          :src="getImageFullUrl(image.imageUrl)"
                          style="
                            object-fit: scale-down;
                            max-width: 100%;
                            max-height: 100%;
                          "
                          align="center"
                          loading="eager"
                        />
                        <v-spacer />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-spacer />
              </v-row>

              <v-btn
                v-if="post && !post.topicClosed && userIsLoggedIn"
                class="ma-2 teal eps_white"
                outlined
                :to="
                  '/forumpost/reply/' +
                  $route.params.board_id +
                  '/' +
                  post.topicId +
                  '/' +
                  post.id +
                  '/' +
                  encodeSubject(post.subject)
                "
              >
                Reply
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-reply theme--light"
                  style="font-size: 16px"
                ></i>
              </v-btn>

              <v-btn
                v-if="post && !post.topicClosed && userIsLoggedIn"
                class="ma-2 teal eps_white"
                outlined
                :to="
                  '/forumpost/quote/' +
                  $route.params.board_id +
                  '/' +
                  post.topicId +
                  '/' +
                  post.id +
                  '/' +
                  encodeSubject(post.subject)
                "
              >
                Quote
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-format-quote-close theme--light"
                  style="font-size: 16px"
                ></i>
              </v-btn>

              <v-btn
                v-if="(post.owner || userIsModerator()) && !post.topicClosed"
                class="ma-2 teal eps_white"
                outlined
                :to="
                  '/forumpost/edit/' +
                  $route.params.board_id +
                  '/' +
                  post.topicId +
                  '/' +
                  post.id
                "
              >
                Edit
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-pen theme--light"
                  style="font-size: 16px"
                ></i>
              </v-btn>

              <v-btn
                v-if="(post.owner && !post.topicClosed) || userIsModerator()"
                class="ma-2 red eps_white"
                outlined
                @click="showDialog(post)"
              >
                Delete
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-delete theme--light"
                  style="font-size: 16px"
                ></i>
              </v-btn>

              <v-btn
                v-if="userIsModerator()"
                class="ma-2 teal eps_white"
                outlined
                @click="changePostVisibility(post)"
              >
                {{ getHideOrShowText(post) }}
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-eye theme--light"
                  style="font-size: 16px"
                ></i>
              </v-btn>

              <v-btn
                v-if="userIsLoggedIn"
                class="ma-2 teal eps_white"
                outlined
                @click="reportPost(post)"
              >
                Report
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-alert theme--light"
                  style="font-size: 16px"
                ></i>
              </v-btn>

              <v-btn
                v-if="userIsLoggedIn && !post.owner"
                class="ma-2 warning eps_white pa-0"
                outlined
                :to="'/mail/' + post.userId"
              >
                PM
                <i
                  aria-hidden="true"
                  class="v-icon notranslate v-icon--center mdi mdi-email-newsletter theme--light"
                  style="font-size: 16px"
                ></i>
              </v-btn>

              <v-btn
                v-if="userIsLoggedIn"
                :class="getHeartClassStyle(post)"
                @click="flipLikePost(post)"
              >
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-heart theme--light"
                  style="font-size: 16px"
                ></i>
                {{ post.likes }}
              </v-btn>

              <v-row v-if="post.signature">
                <v-col cols="12">
                  <v-divider />
                  <v-card-text
                    v-html="post.signature"
                    style="overflow: hidden"
                  ></v-card-text>
                </v-col>
              </v-row>
            </v-card>
            <v-spacer />
          </v-col>
        </v-row>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row class="ma-0 pa-0">
      <v-spacer />
      <v-col cols="12" sm="11" class="ma-0 pa-0">
        <v-pagination
          class="ma-0 pa-0"
          v-if="apiData"
          v-model="page"
          :length="getPagesAvailable"
          :total-visible="10"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          circle
          @input="paginationChanged()"
        ></v-pagination>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row>
      <v-spacer />
      <v-col cols="11">
        <v-card class="mx-auto">
          <v-toolbar color="teal" dark>
            <v-toolbar-title style="color: white; font-size: 1rem">
              <router-link to="/forum/1" v-slot="{ href }" custom>
                <a @click="navigateBackToTopicList(href)" style="color: white"
                  >Plant Forum</a
                >
              </router-link>
              |
              <router-link to="/forum/2" v-slot="{ href }" custom>
                <a @click="navigateBackToTopicList(href)" style="color: white"
                  >Swaps &amp; Sales</a
                >
              </router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
    <div class="text-center">
      <v-dialog v-if="this.selectedPost" v-model="dialogVisible" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> Confirm Delete </v-card-title>

          <v-card-subtitle class="ma-4 pa-4">
            Please confirm you want to delete this post
            <br /><br />
            This action cannot be undone
          </v-card-subtitle>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="error" text @click="dialogCancelled()"> Cancel </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogConfirmed()">
              Confirm Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center">
      <v-dialog
        v-if="userIsModerator() && this.apiData && this.apiData.length > 0"
        v-model="showConfirmDelete"
        width="500"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> Confirm Delete </v-card-title>

          <v-card-subtitle class="ma-4 pa-4">
            Please confirm you want to delete this whole topic
            <br /><br />
            This action cannot be undone
          </v-card-subtitle>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="error" text @click="showConfirmDelete = false"> Cancel </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteCurrentTopic()">
              Delete Topic
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="userIsModerator() && this.apiData && this.apiData.length > 0"
        v-model="showMoveTopic"
        width="500"
      >
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"> Move Topic </v-card-title>

          <v-card-subtitle class="ma-4 pa-4">
            Select The Board To Move This Topic To
            <br /><br />
            <v-radio-group v-model="newBoardId">
              <v-radio v-for="board in boards" :key="board.id" :value="board.id">
                <template v-slot:label>
                  <span v-html="board.title" />
                </template>
              </v-radio>
            </v-radio-group>
          </v-card-subtitle>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="error" text @click="showMoveTopic = false"> Cancel </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="moveTopic()"> Move Topic </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center">
      <v-dialog v-if="this.selectedPost" v-model="showReportPostScreen" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Report Suspicious Post
          </v-card-title>

          <v-card-subtitle class="ma-4 pa-4">
            Click below to report this post to the admin team.
            <br /><br />
            Please feel free to add some commentary on why you are reporting this post
          </v-card-subtitle>

          <v-textarea
            class="mt-4 pt-4 ml-4 mr-4 pl-4 pr-4"
            v-model="reportReason"
            label="Report reason"
            outlined
          >
          </v-textarea>
          <v-alert
            dismissible
            close-text="Close Alert"
            border="left"
            :type="reportPostResponseStatus"
            v-if="reportPostResponseStatus"
          >
            {{ reportPostResponseMessage }}
          </v-alert>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="error" text @click="closeReportPostScreen()"> Close </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              v-if="!(reportPostResponseStatus == 'success')"
              :loading="reportPostProcessing"
              text
              @click="sendReportPostMessage()"
            >
              Report
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script />

<script>
import userFunctions from "@/functions/userFunctions";
import serverFunctions from "@/functions/serverFunctions";
import dateFunctions from "@/functions/dateFunctions";
import stringFunctions from "@/functions/stringFunctions";
import forumFunctions from "@/functions/forumFunctions";
import dataStore from "@/functions/dataStore";

export default {
  components: {},
  methods: {
    navigateBackToTopicList(path) {
      dataStore.clearPagingValues();
      this.$router.push(path);
    },
    atMax3Paragraphs(text) {
      return stringFunctions.atMax3Paragraphs(text);
    },
    formatPostTextForDisplay(post) {
      return forumFunctions.formatPostTextForDisplay(post);
    },
    imageLoaded(event) {
      this.initialScroll();

      if (this.$refs.userImage.filter((image) => image.isLoading).length == 0) {
        this.allImagesLoaded = true;
      }
    },
    preloadImages() {
      let imageUrls = this.apiData;
      for (let postIndex in this.apiData) {
        let post = this.apiData[postIndex];
        for (let imageIndex in post.postImages) {
          let image = post.postImages[imageIndex];
          this.preloadImage(image.imageUrl);
        }
      }
    },
    preloadImage(im_url) {
      let url = this.getImageFullUrl(im_url);
      let img = new Image();
      img.src = url;
    },
    encodeSubject(subject) {
      return encodeURIComponent(subject);
    },
    getLocationText(post) {
      if (post.country) {
        let fullLocation = this.getFullLocation(post.county, post.country);
        if (fullLocation.trim().length > 0) {
          return "(" + fullLocation + ")";
        }
      }
      return "";
    },
    getOldImageUrl(postId, image) {
      let imageUrl = "http://old.palmsociety.org.uk/forum/images/" + postId + "/" + image;

      return "https://wsrv.nl/?url=" + imageUrl;
    },
    getHeartClassStyle(post) {
      var heartClass = "ma-2 pa-0 ";
      if (post.likes > 0) {
        heartClass += post.liked ? "red eps_white" : "primary eps_white";
      }
      return heartClass;
    },
    async flipLikePost(post) {
      let likePostRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        post.id
      );

      let path = post.liked ? "/dislikePost" : "/likePost";
      let data = await serverFunctions.getPostResponse(path, likePostRequest);

      for (var i = 0; i < this.pageData.length; i++) {
        if (this.pageData[i].id === post.id) {
          this.pageData[i].liked = data[0].liked;
          this.pageData[i].likes = data[0].likes;

          return;
        }
      }
    },
    getSmSizeForImage(image, postImages) {
      let index = postImages.indexOf(image);

      return index === postImages.length - 1 && index % 2 === 0 ? "6" : "6"; //was 12, but single images are massive!
    },
    getFullLocation(region, country) {
      if (region && country && region.trim().length > 0 && country.trim().length > 0) {
        return region.trim() + ", " + country.trim();
      } else if (country.trim().length > 0) {
        return country;
      } else if (region.trim().length > 0) {
        return region;
      } else {
        return "";
      }
    },
    getImageFullUrl(imagePath) {
      return forumFunctions.getImageFullUrl(imagePath);
    },
    async rotatePostImage(post, image, degrees) {
      this.$set(image, "loading", true);

      degrees < 0 ? (image.loadingLeft = true) : (image.loadingRight = true);
      let imagePath = image.imageUrl.substring(image.imageUrl.indexOf("user-content"));

      let rotatePostImageRequest = serverFunctions.getRotatePostImageRequest(
        userFunctions.getLoggedInUser(),
        post.id,
        imagePath,
        degrees
      );

      let rotateImageResponse = await serverFunctions.getPostResponse(
        "/rotatePostImage",
        rotatePostImageRequest
      );

      if (rotateImageResponse[0].success) {
        image.imageUrl = rotateImageResponse[0].uploadedFileAndPathWithoutServer;
      }
      image.loading = false;
      image.loadingLeft = false;
      image.loadingRight = false;
    },
    cardElevation(post) {
      if (post.id == this.$route.params.post_id) {
        return 24;
      } else {
        return 16;
      }
    },
    getTopicClosedColour(topic) {
      if (topic.topicClosed) {
        return "warning";
      }
    },
    getTopicStickyColour(topic) {
      if (topic.topicSticky) {
        return "yellow";
      }
    },
    getTopicAnnouncementColour(topic) {
      if (topic.topicAnnouncement) {
        return "yellow";
      }
    },
    getFullAvatarUrl(avatar) {
      return userFunctions.getFullAvatarUrl(avatar);
    },
    getSelectedPostStartingText() {
      return this.selectedPost.message;
    },
    showDialog(eventDetail) {
      this.selectedPost = eventDetail;
      this.dialogVisible = true;
    },
    async dialogConfirmed() {
      await this.deletePost(this.selectedPost.id);
      this.dialogVisible = false;
    },
    dialogCancelled() {
      this.dialogVisible = false;
    },
    getUser(id) {
      return userFunctions.getUser(id);
    },
    userIsModerator() {
      return userFunctions.currentUserIsModerator();
    },
    htmlDecode(text) {
      return stringFunctions.htmlDecode(text);
    },
    formatPostMessage(post) {
      return forumFunctions.formatPostTextForDisplay(post);
    },
    formatDateTime(date, time) {
      return dateFunctions.formatPalmDateTime(date, time);
    },
    formatDate(date) {
      return dateFunctions.formatPalmDate(date);
    },
    postIsVisible(post) {
      return post.visible == 1;
    },
    getHideOrShowText(post) {
      return post.visible == 1 ? "Hide" : "Unhide";
    },
    getPostBackgroundColour(post) {
      return post.visible == 1 ? "" : "background:lightgrey";
    },
    scrollToPost(id) {
      if (!id || !this.apiData) {
        return;
      }
      this.updatePageToDisplayPost(id);
      this.postToScrollTo = id;
      this.$nextTick(() => {
        let scrollTarget = "#post" + id;
        this.$vuetify.goTo(scrollTarget, this.scrollingOptions);
      });
    },
    scrollToTopOfPage() {
      this.$nextTick(() => {
        this.$vuetify.goTo("#palmSiteHeaderToolbar", this.scrollingOptions);
        this.$nextTick(() => {
          this.$vuetify.goTo("#palmSiteHeaderToolbar", this.scrollingOptions);
        });
      });
    },
    updatePageToDisplayPost(id) {
      if (!this.apiData) {
        return;
      }

      for (var i = 0; i <= this.apiData.length; i++) {
        if (this.apiData[i].id == id) {
          let newPage = Math.floor(i / this.pageSize) + 1;
          if (this.page != newPage) {
            this.page = newPage;
            this.updatePostData();
          }
          return;
        }
      }
    },
    closeReportPostScreen() {
      this.showReportPostScreen = false;
      this.reportPostResponseStatus = null;
      this.reportPostResponseMessage = null;
    },
    reportPost(post) {
      this.selectedPost = post;
      this.showReportPostScreen = true;
    },
    async sendReportPostMessage() {
      if (!this.selectedPost) {
        return;
      }

      let boardId = this.$route.params.board_id;
      let topicId = this.$route.params.topic_id;

      let reportPostRequest = serverFunctions.getReportPostRequest(
        userFunctions.getLoggedInUser(),
        boardId,
        topicId,
        this.selectedPost.id,
        this.reportReason
      );

      this.reportPostProcessing = true;

      let reportPostResponse = await serverFunctions.getRawPostResponse(
        "/reportPost",
        reportPostRequest
      );

      this.reportPostProcessing = false;

      if (reportPostResponse && reportPostResponse.success) {
        this.reportPostResponseStatus = "success";
        this.reportPostResponseMessage =
          "Thank you, our admin team will be in touch. Click Close to return to the site";
      } else {
        this.reportPostResponseStatus = "error";
        this.reportPostResponseMessage =
          "The request failed, please try again or email info@palmsociety.org.uk";
      }
    },
    async changePostVisibility(post) {
      let updatePostRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        post.id
      );

      let serverAction = post.visible == 1 ? "/hidePost" : "/showPost";

      await serverFunctions.getPostResponse(serverAction, updatePostRequest);

      let topicId = this.$route.params.topic_id;

      const topicPostRequest = serverFunctions.getPagedDataRequestObject(
        userFunctions.getLoggedInUser(),
        topicId,
        9999,
        0 //get all, slice client side for performance
      );

      this.apiData = await serverFunctions.getPostResponse(
        "/getTopicPosts",
        topicPostRequest
      );

      this.updatePostData();
    },
    async toggleSticky(topic) {
      let updateTopicRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        topic.topicId
      );

      let serverAction = topic.topicSticky ? "/makeTopicNotSticky" : "/makeTopicSticky";

      await serverFunctions.getPostResponse(serverAction, updateTopicRequest);

      const topicPostRequest = serverFunctions.getPagedDataRequestObject(
        userFunctions.getLoggedInUser(),
        topic.topicId,
        9999,
        0 //get all, slice client side for performance
      );

      this.apiData = await serverFunctions.getPostResponse(
        "/getTopicPosts",
        topicPostRequest
      );

      this.updatePostData();
    },
    async toggleClosed(topic) {
      let updateTopicRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        topic.topicId
      );

      let serverAction = topic.topicClosed ? "/makeTopicNotClosed" : "/makeTopicClosed";

      await serverFunctions.getPostResponse(serverAction, updateTopicRequest);

      const topicPostRequest = serverFunctions.getPagedDataRequestObject(
        userFunctions.getLoggedInUser(),
        topic.topicId,
        9999,
        0 //get all, slice client side for performance
      );

      this.apiData = await serverFunctions.getPostResponse(
        "/getTopicPosts",
        topicPostRequest
      );

      this.updatePostData();
    },
    async toggleAnnouncement(topic) {
      let updateTopicRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        topic.topicId
      );

      let serverAction = topic.topicAnnouncement
        ? "/makeTopicNotAnnouncement"
        : "/makeTopicAnnouncement";

      await serverFunctions.getPostResponse(serverAction, updateTopicRequest);

      const topicPostRequest = serverFunctions.getPagedDataRequestObject(
        userFunctions.getLoggedInUser(),
        topic.topicId,
        9999,
        0 //get all, slice client side for performance
      );

      this.apiData = await serverFunctions.getPostResponse(
        "/getTopicPosts",
        topicPostRequest
      );

      this.updatePostData();
    },
    async deletePost(postId) {
      let topicOriginalPostId = this.apiData[0].id;
      if (postId == topicOriginalPostId) {
        let topicId = this.$route.params.topic_id;
        await this.deleteTopic(topicId);
        return;
      }

      let deletePostRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        postId
      );

      await serverFunctions.getPostResponse("/deletePost", deletePostRequest);
      window.location.reload(true);
      // this.$router.push("/forum/" + this.$route.params.board_id);
    },
    confirmDeleteCurrentTopic() {
      this.showConfirmDelete = true;
    },
    showMoveTopicDialog() {
      this.showMoveTopic = true;
    },
    async deleteCurrentTopic() {
      await this.deleteTopic(this.$route.params.topic_id);
    },
    async deleteTopic(topicId) {
      let deleteTopicRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser(),
        topicId
      );

      await serverFunctions.getPostResponse("/deleteTopic", deleteTopicRequest);
      this.$router.push("/forum/" + this.$route.params.board_id);
    },
    async moveTopic() {
      let topicId = this.$route.params.topic_id;
      let boardId = this.newBoardId;

      let moveTopicRequest = serverFunctions.moveTopicRequest(
        userFunctions.getLoggedInUser(),
        topicId,
        boardId
      );

      await serverFunctions.getPostResponse("/moveTopic", moveTopicRequest);
      this.$router.push("/forum/" + boardId);
    },
    async getAPIData() {
      const boardRequest = serverFunctions.getDataRequestObject(
        userFunctions.getLoggedInUser()
      );
      this.boards = await serverFunctions.getPostResponse("/getBoards", boardRequest);

      let topicId = this.$route.params.topic_id;

      const topicPostRequest = serverFunctions.getPagedDataRequestObject(
        userFunctions.getLoggedInUser(),
        topicId,
        9999,
        0 //get all, slice client side for performance
      );

      this.apiData = await serverFunctions.getPostResponse(
        "/getTopicPosts",
        topicPostRequest
      );

      userFunctions.updateUnreadMessageCount();

      this.preloadImages();

      this.updatePostData();

      this.$nextTick(() => {
        this.initialScroll();
      });

      this.postTitle = this.apiData[0].subject;
      this.postText = this.atMax3Paragraphs(this.formatPostMessage(this.apiData[0]));
    },
    initialScroll() {
      if (this.pagerClicked || this.allImagesLoaded) {
        return;
      }
      this.$nextTick(() => {
        if (this.postId) {
          setTimeout(() => {
            this.scrollToPost(this.postId);
          }, 100);
        } else {
          setTimeout(() => {
            this.scrollToFirstUnreadPost();
          }, 100);
        }
      });
    },
    paginationChanged() {
      this.pagerClicked = true;
      this.updatePostData();
      this.$nextTick(() => {
        this.scrollToTopOfPage();
      });
    },
    updatePostData() {
      if (this.apiData && this.apiData.length == 0) {
        this.$router.push("/forum/" + this.$route.params.board_id);
      }
      this.pageData = this.apiData.slice(
        (this.page - 1) * this.pageSize,
        this.page * this.pageSize
      );
    },
    scrollToFirstUnreadPost() {
      if (!this.pageData) {
        return;
      }
      for (var i = 0; i < this.apiData.length; i++) {
        if (!this.apiData[i].messageRead) {
          this.scrollToPost(this.apiData[i].id);
          return;
        }
      }
      this.scrollToPost(this.apiData[this.apiData.length - 1].id);
    },
  },
  computed: {
    smallScreen() {
      return this.$vuetify.breakpoint.smOnly;
    },
    smallScreenAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    userIsLoggedIn() {
      return userFunctions.userIsLoggedIn();
    },
    getPagesAvailable: function () {
      if (this.apiData) {
        return Math.floor((this.apiData.length - 1) / this.pageSize) + 1;
      } else {
        return 0;
      }
    },
    boardId() {
      return this.$route.params.board_id;
    },
    topicId() {
      return this.$route.params.topic_id;
    },
    postId() {
      return this.$route.params.post_id;
    },
    scrollingOptions() {
      return {
        duration: 300,
        offset: 20,
      };
    },
  },
  data: () => ({
    apiData: null,
    pageData: null,
    page: 1,
    pageSize: 10,
    selectedPost: null,
    dialogVisible: false,
    showReportPostScreen: false,
    reportReason: null,
    reportPostResponseStatus: null,
    reportPostResponseMessage: null,
    reportPostProcessing: false,
    showConfirmDelete: false,
    showMoveTopic: false,
    boards: null,
    newBoardId: null,
    allImagesLoaded: false,
    pagerClicked: false,
    postTitle: "",
    postText: "",
  }),
  beforeMount() {
    this.getAPIData();
  },
  metaInfo() {
    const postTitle = this.postTitle;
    const postText = this.postText;
    return {
      title: postTitle,
      meta: [
        {
          name: "description",
          content: postText,
        },
      ],
    };
  },
};
</script>

<style scoped>
.name {
  color: darkslategrey;
}

.overflow-fix .v-toolbar__content {
  height: auto !important;
  flex-wrap: wrap;
}

.ma-0 {
  margin: 0;
}
</style>
